import React from "react"
import useStyles from "@/popups/templates/CheckboxSurvey/styles"

import { Grid, Typography } from "@material-ui/core"
import { CheckboxSelector } from "@/popups/components/CheckboxSelector"

const OPTIONS = [
	{ value: "facilidade", label: "Facilidade de uso" },
	{ value: "velocidade", label: "Velocidade da plataforma" },
	{ value: "integracao", label: "Integrações disponíveis" },
	{ value: "suporte", label: "Qualidade do suporte" },
	{ value: "automacao", label: "Automação de mensagens" },
	{ value: "relatorios", label: "Relatórios e métricas" },
	{ value: "atendimento", label: "Atendimento ao cliente" }
]

export type CheckboxSurveyValue = {
	selected: string[]
	otherText: string
}

export type CheckboxSurveyProps = {
	value: CheckboxSurveyValue
	onChange: (value: CheckboxSurveyValue) => void
	title?: string
}

export const CheckboxSurvey: React.FC<CheckboxSurveyProps> = ({
	value,
	onChange,
	title = "O que mais te agrada na Letalk?"
}) => {
	const classes = useStyles()

	return (
		<Grid container direction="column" spacing={2}>
			<Grid item>
				<Typography className={classes.title}>{title}</Typography>
			</Grid>

			<Grid item>
				<Typography className={classes.questionLabel}>
					1. Selecione todos os aspectos que se aplicam:
				</Typography>
				<CheckboxSelector
					options={OPTIONS}
					value={value.selected}
					onChange={(selected) => onChange({ ...value, selected })}
					allowOther
					otherText={value.otherText}
					onOtherTextChange={(otherText) => onChange({ ...value, otherText })}
				/>
			</Grid>
		</Grid>
	)
}
